/*
 * Iter 31.302 — 277-Agent Ensemble Hero.
 *
 * Six's brief: once one of Gemini / nano banana / Copilot / ChatGPT
 * wins the group-photo showdown, pipe the winner into Drive as
 * `spy_finance_ensemble_v1.png`. The `/api/generated/<name>` mirror
 * already handles Drive-fallback + local caching, so the front-end
 * just needs to point at the URL — no bespoke plumbing required.
 *
 * Failure mode: until the image exists, the mirror 404s. This
 * component hides itself on error (no broken-image glyph, no ugly
 * placeholder) so nothing changes on Home.jsx until the winner is in
 * place. Once it's there, the hero appears on next page load.
 *
 * Filename versioned (`_v1`) so future re-shoots don't fight the CDN
 * cache — bump to `_v2` on next round and swap the constant here.
 */
import React, { useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const ENSEMBLE_FILENAME = "spy_finance_ensemble_v1.png";

export default function EnsembleHero() {
    const [loaded, setLoaded] = useState(false);
    const [failed, setFailed] = useState(false);

    if (failed) return null; // graceful no-op when the winner isn't uploaded yet

    return (
        <div
            className={`paper-card border-2 border-ink/25 mb-6 overflow-hidden relative transition-opacity duration-500 ${loaded ? "opacity-100" : "opacity-0"}`}
            data-testid="home-ensemble-hero"
            style={{ minHeight: loaded ? undefined : 0 }}
        >
            <img
                src={`${API}/api/generated/${ENSEMBLE_FILENAME}`}
                alt="277-agent ensemble portrait"
                onLoad={() => setLoaded(true)}
                onError={() => setFailed(true)}
                className="w-full h-auto block"
                data-testid="ensemble-hero-img"
            />
            {loaded ? (
                <div
                    className="absolute bottom-0 left-0 right-0 px-4 py-3 flex items-baseline justify-between gap-3"
                    style={{
                        background: "linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,0.72))",
                    }}
                    data-testid="ensemble-hero-caption"
                >
                    <div className="font-heading uppercase tracking-[0.22em] text-[10px] text-white/90">
                        277 operatives · one shed
                    </div>
                    <div className="font-mono text-[9px] text-white/60">
                        ensemble v1
                    </div>
                </div>
            ) : null}
        </div>
    );
}
